'use client';

import dynamic from 'next/dynamic';
import { memo, useState } from 'react';
import ExpandArrowIcon from '@upzi/web-shell/icons/expand-arrow-icon';
import { Button } from '@upzi/web-shell/ui/button';
import { cn } from '@/lib/utils';
import { ALL_JOB_FILTERS } from '@/services/jobs';
import type { MobileJobFilterControlSheetProps } from './mobile-job-filter-control-sheet';
import {
  MOBILE_JOB_FILTER_TRIGGER_ACTIVE_CLASSNAME,
  MOBILE_JOB_FILTER_TRIGGER_CLASSNAME,
} from './mobile-job-filter-trigger-styles';

const MobileJobFilterControlSheet = dynamic(
  () =>
    import('./mobile-job-filter-control-sheet').then(
      module => module.MobileJobFilterControlSheet
    ),
  {
    ssr: false,
    loading: () => (
      <Button
        type="button"
        variant="outline"
        disabled
        className={MOBILE_JOB_FILTER_TRIGGER_CLASSNAME}
      >
        Đang tải…
      </Button>
    ),
  }
);

export const LazyMobileJobFilterControlSheet = memo(
  function LazyMobileJobFilterControlSheet(
    props: MobileJobFilterControlSheetProps
  ) {
    const [isActivated, setIsActivated] = useState(false);
    const { definition, options } = props.group;
    const selectedValue = props.filters[definition.stateKey];
    const activeFilterCount = Array.isArray(selectedValue)
      ? selectedValue.length
      : selectedValue === ALL_JOB_FILTERS
        ? 0
        : 1;
    const selectedOptionValue = Array.isArray(selectedValue)
      ? selectedValue[0]
      : selectedValue;
    const selectedOption =
      activeFilterCount === 1
        ? options.find(option => String(option.id) === selectedOptionValue)
        : undefined;
    const triggerLabel = selectedOption?.value ?? definition.label;

    if (isActivated) {
      return <MobileJobFilterControlSheet {...props} defaultOpen />;
    }

    return (
      <Button
        type="button"
        variant="outline"
        onClick={() => setIsActivated(true)}
        className={cn(
          MOBILE_JOB_FILTER_TRIGGER_CLASSNAME,
          'max-w-[220px]',
          activeFilterCount > 0 && MOBILE_JOB_FILTER_TRIGGER_ACTIVE_CLASSNAME
        )}
      >
        <span className="min-w-0 truncate">
          {triggerLabel}
          {activeFilterCount > 1 ? ` (${activeFilterCount})` : ''}
        </span>
        <ExpandArrowIcon size={16} aria-hidden />
      </Button>
    );
  }
);
